import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Button,
} from "@material-ui/core";
import clsx from "clsx";
import { useStyles } from "./styles";

const OneParkAccountTable = ({ rows, order, orderBy, onSort, onRowClick, onCloseTransaction, rewardsEnabled }) => {
  const classes = useStyles();
  const hasActions =
    !!onCloseTransaction &&
    rows.some((row) => String(row.status).toLowerCase() === "in");

  const columns = [
    { key: "email", label: "Emails" },
    ...(rewardsEnabled ? [{ key: "points", label: "Points" }] : []),
    { key: "signupDate", label: "Signup Date" },
    { key: "lastUse", label: "Last Use" },
    { key: "accountBalance", label: "Account Balance" },
    { key: "status", label: "Status" },
    ...(hasActions ? [{ key: "actions", label: "Actions", sortable: false }] : []),
  ];

  return (
    <Table className={clsx(classes.table, "onepark-account-table")}>
        <TableHead>
          <TableRow className={clsx(classes.headerRow, "onepark-account-header-row")}>
            {columns.map((col) => (
              <TableCell key={col.key} className={clsx(classes.headerCell, `onepark-account-header-${col.key}`)}>
                {col.sortable === false ? col.label : (
                  <TableSortLabel
                    active={orderBy === col.key}
                    direction={orderBy === col.key ? order : "asc"}
                    onClick={() => onSort(col.key)}
                  >
                    {col.label}
                  </TableSortLabel>
                )}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row) => (
            <TableRow 
              key={row.id} 
              className={clsx(classes.bodyRow, classes.clickableRow, `onepark-account-row-${row.id}`)}
              onClick={() => onRowClick && onRowClick(row)}
            >
              <TableCell className={clsx(classes.bodyCell, "onepark-account-cell-email")}>{row.email || "–"}</TableCell>
              {rewardsEnabled && <TableCell className={clsx(classes.bodyCell, "onepark-account-cell-points")}>{row.points || "-"}</TableCell>}
              <TableCell className={clsx(classes.bodyCell, "onepark-account-cell-signupDate")}>{row.signupDate || "–"}</TableCell>
              <TableCell className={clsx(classes.bodyCell, "onepark-account-cell-lastUse")}>{row.lastUse || "–"}</TableCell>
              <TableCell className={clsx(classes.bodyCell, "onepark-account-cell-accountBalance")}>{row.accountBalance || "-"}</TableCell>
              <TableCell className={clsx(classes.bodyCell, "onepark-account-cell-status")}>{row.status || "–"}</TableCell>
              {hasActions && (
                <TableCell
                  className={clsx(classes.bodyCell, "onepark-account-cell-actions")}
                  style={{ minWidth: 160 }}
                  onClick={(e) => e.stopPropagation()}
                >
                  {String(row.status).toLowerCase() === "in" && (
                    <Button
                      size="small"
                      variant="outlined"
                      color="secondary"
                      onClick={() => onCloseTransaction(row)}
                      className="close-transaction-btn"
                      data-testid={`close-transaction-btn-${row.id}`}
                    >
                      Close Transaction
                    </Button>
                  )}
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
    </Table>
  );
};

export default OneParkAccountTable;